import { cn } from '../../../utils/common-utils.ts';

interface IProps {
  className?: string;
  filled?: boolean;
  fillColor?: string;
  strokeColor?: string;
}

const ForReviewFlagIcon = ({
  className,
  filled = true,
  fillColor,
  strokeColor = '#1F1F1F',
}: IProps) => {
  return (
    <svg
      viewBox="0 0 15 18"
      fill="none"
      aria-hidden="true"
      className={cn('shrink-0', className)}
    >
      <path
        d="M2.25 1.5H12.25V16.4L7.25 10.7L2.25 16.4V1.5Z"
        fill={fillColor ?? (filled ? '#C93A4D' : 'white')}
        stroke={strokeColor}
        strokeWidth="1.35"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ForReviewFlagIcon;
